import React, { useEffect, useState } from 'react'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import Carousel from '../../ui/Carousel/Carousel'
import './PortfolioGallery.sass'
import getDoc from '../../utils/db/getDoc'
import { isEmpty } from 'lodash'

function PortfolioGallery() {
  const [slider, setSlider] = useState(null)
  console.log('🚀 ~ PortfolioGallery ~ slider:', slider)

  useEffect(() => {
    getDoc({ path: 'slider', docId: 'homeSlider' }).then((data) =>
      setSlider(data)
    )
  }, [])

  return (
    <section className="PortfolioGallery">
      <div className="DefaultContainer">
        <SectionTitle title="Ми в роботі" />
        {!isEmpty(slider) && (
          <Carousel
            element="PortfolioGallery-Carousel"
            options={{
              type: 'carousel',
              gap: 24,
              perView: 3,
              hoverpause: true,
              // autoplay: 5000,
              // useDots: true,
              useArrows: true,
              breakpoints: {
                // 1200: { perView: 3 },
                // 992: { perView: 2 },
                576: { perView: 1 },
              },
            }}
          >
            {slider.photos
              .filter((p) => p.isLayout === false)
              .map((p) => (
                <a href={p.publicUrl} data-fancybox>
                  <img src={p.publicUrl} alt="" />
                </a>
              ))}
          </Carousel>
        )}
      </div>
    </section>
  )
}

export default PortfolioGallery
